class VentiLoader extends HTMLElement {
  connectedCallback() {
    this.frame = 0;
    this.releaseTimer = null;
    this.hideTimer = null;

    try {
      if (window.sessionStorage.getItem("venti-loader-seen-v3")) {
        this.remove();
        return;
      }
    } catch {}

    const duration = Math.max(1, Number(this.dataset.duration) || 1.5) * 1000;
    const startedAt = performance.now();
    const percentage = this.querySelector("[data-loader-percentage]");

    const count = (now) => {
      const progress = Math.min(100, Math.round(((now - startedAt) / duration) * 100));
      this.style.setProperty("--loader-progress", `${progress * 1.15}%`);
      this.style.setProperty("--loader-scale", `${Math.max(progress / 100, 0.001)}`);
      if (percentage) percentage.textContent = `${progress}%`;

      if (progress < 100) this.frame = window.requestAnimationFrame(count);
      else this.release();
    };

    this.frame = window.requestAnimationFrame(count);
    this.releaseTimer = window.setTimeout(() => this.release(), duration + 900);
  }

  release() {
    if (this.classList.contains("is-done")) return;

    try {
      window.sessionStorage.setItem("venti-loader-seen-v3", "true");
    } catch {}

    window.clearTimeout(this.releaseTimer);
    this.classList.add("is-done");
    this.hideTimer = window.setTimeout(() => this.classList.add("is-hidden"), 450);
  }

  disconnectedCallback() {
    if (this.frame) window.cancelAnimationFrame(this.frame);
    window.clearTimeout(this.releaseTimer);
    window.clearTimeout(this.hideTimer);
  }
}

class DepthEditorial extends HTMLElement {
  connectedCallback() {
    this.frame = 0;
    this.requestUpdate = this.requestUpdate.bind(this);
    this.updateTilt = this.updateTilt.bind(this);
    this.resetTilt = this.resetTilt.bind(this);
    this.updateProgress();

    window.addEventListener("scroll", this.requestUpdate, { passive: true });
    window.addEventListener("resize", this.requestUpdate);
    this.addEventListener("pointermove", this.updateTilt);
    this.addEventListener("pointerleave", this.resetTilt);
  }

  requestUpdate() {
    if (!this.frame) this.frame = window.requestAnimationFrame(() => this.updateProgress());
  }

  updateProgress() {
    this.frame = 0;
    const rect = this.getBoundingClientRect();
    const travel = window.innerHeight + rect.height;
    const progress = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / travel));
    this.style.setProperty("--depth-progress", progress.toFixed(4));
  }

  updateTilt(event) {
    if (event.pointerType === "touch") return;
    const rect = this.getBoundingClientRect();
    const x = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
    const y = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));
    const rotation = Number.parseFloat(getComputedStyle(this).getPropertyValue("--depth-editorial-rotation")) || 4;
    this.style.setProperty("--depth-x", `${((0.5 - y) * rotation).toFixed(2)}deg`);
    this.style.setProperty("--depth-y", `${((x - 0.5) * rotation).toFixed(2)}deg`);
  }

  resetTilt() {
    this.style.setProperty("--depth-x", "0deg");
    this.style.setProperty("--depth-y", "0deg");
  }

  disconnectedCallback() {
    if (this.frame) window.cancelAnimationFrame(this.frame);
    window.removeEventListener("scroll", this.requestUpdate);
    window.removeEventListener("resize", this.requestUpdate);
    this.removeEventListener("pointermove", this.updateTilt);
    this.removeEventListener("pointerleave", this.resetTilt);
  }
}

if (!customElements.get("venti-loader")) customElements.define("venti-loader", VentiLoader);
if (!customElements.get("depth-editorial")) customElements.define("depth-editorial", DepthEditorial);